import React from 'react';
import "../components/Header.scss";

const Header = () => {
    return (
        <>
        <div id="header">
        <i className="fas fa-info-circle"></i>
        <div className="header_head">
            <h4> READ ABOUT OUR COVID-19 PRECAUTIONS</h4>
        </div>
        </div>
            
        </>
    )
}

export default Header;
